import { FC } from 'react';
import { useTrans } from 'base/utils/i18n';
import { GiftsTrigger } from 'mod/product/GiftsTrigger';
import { IGiftItem } from 'base/interfaces/product';
import { ThemeModal } from '@base/lib/ThemeModal';
import { GiftsPopupBody } from 'mod/product/GiftsPopupBody';
import { ProductDetailPopup } from '@app/common/ProductDetailPopup';
import { useProdGifts } from 'mod/product/useProdGifts';
import cn from 'classnames';
import styles from './index.module.less';

type IProdGiftsProps = {
    gifts: IGiftItem[];
    className?: string;
};

export const ProdGifts: FC<IProdGiftsProps> = props => {
    const { gifts, className } = props;
    const { t } = useTrans();
    const {
        giftsPopupVisible,
        openGiftsPopup,
        closeGiftsPopup,

        quickViewVisible,
        quickViewVariantId,
        openQuickView,
        closeQuickView,
    } = useProdGifts();

    return !gifts.length ? null : (
        <>
            <GiftsTrigger
                className={cn(className, styles.trigger)}
                gifts={gifts}
                openPopup={openGiftsPopup}
            />

            <ThemeModal
                title={t('web_common_free_gift')}
                className={styles.popup}
                open={giftsPopupVisible}
                onCancel={closeGiftsPopup}
                width={370}
                footer={false}
            >
                <GiftsPopupBody
                    gifts={gifts}
                    onQuickView={openQuickView}
                />
            </ThemeModal>

            <ProductDetailPopup
                visible={quickViewVisible}
                onClose={closeQuickView}
                variantId={quickViewVariantId}
                elements={[
                    'pictures',
                    'name',
                    'reviews',
                ]}
                pageFrom={'gifts'}
            />
        </>
    )
};
